var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9059 4.36916C17.2301 4.36916 17.5 4.63832 17.5 4.98082V5.29748C17.5 5.63165 17.2301 5.90914 16.9059 5.90914H3.09488C2.76988 5.90914 2.5 5.63165 2.5 5.29748V4.98082C2.5 4.63832 2.76988 4.36916 3.09488 4.36916H5.52464C6.01821 4.36916 6.44775 4.01833 6.55879 3.52334L6.68603 2.95501C6.88378 2.18085 7.53458 1.66669 8.27939 1.66669H11.7206C12.4573 1.66669 13.1154 2.18085 13.3059 2.91417L13.442 3.5225C13.5522 4.01833 13.9818 4.36916 14.4762 4.36916H16.9059ZM15.6714 15.945C15.9251 13.5809 16.3692 7.96429 16.3692 7.90762C16.3854 7.73596 16.3295 7.57346 16.2185 7.44263C16.0993 7.32013 15.9486 7.24763 15.7825 7.24763H4.22367C4.05672 7.24763 3.89787 7.32013 3.78765 7.44263C3.6758 7.57346 3.62069 7.73596 3.6288 7.90762C3.63029 7.91804 3.64622 8.11588 3.67286 8.44664C3.79122 9.916 4.12088 14.0085 4.3339 15.945C4.48464 17.3717 5.42072 18.2684 6.77662 18.3009C7.82293 18.325 8.90084 18.3334 10.0031 18.3334C11.0413 18.3334 12.0957 18.325 13.1744 18.3009C14.5773 18.2767 15.5126 17.3959 15.6714 15.945Z",
    fill: "#8B929D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.7a3172186479d4cbde3eed46ee5bf529.svg";
export { ForwardRef as ReactComponent };